import { render, staticRenderFns } from "./template.vue?vue&type=template&id=f737d3c4&scoped=true&"
import script from "./template.vue?vue&type=script&lang=ts&"
export * from "./template.vue?vue&type=script&lang=ts&"
import style0 from "./template.vue?vue&type=style&index=0&id=f737d3c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f737d3c4",
  null
  
)

export default component.exports